// removed by extract-text-webpack-plugin
module.exports = {"gray500":"#adb5bd","primaryColorBase":"#006CB7","primaryColorLight":"#057acb","primaryColorLighter":"#2fa0ee","primaryColorLightest":"#79bff0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ReCarousel/CarouselAssets/CarouselAssets.scss
// module id = 40
// module chunks = 0